export function toggleInclude(array, item) {
  if (array.includes(item)) {
    array.splice(array.indexOf(item), 1);
  } else {
    array.push(item);
  }
}

export function countElementsByKey(array, key) {
  return array.reduce((prev, cur) => prev + cur[key], 0);
}
